<template>
    <ul>
      <slot name="pre-nav"></slot>
      <!--
      <li>
        <router-link :to="{ 'name': 'factoring-shipper-approvals' }">
          Pending Shipper Approvals
        </router-link>
      </li>
      <li>
        <router-link :to="{ 'name': 'factoring-carrier-approvals' }">
          Pending Carrier Approvals
        </router-link>
      </li>
      -->
      <slot name="post-nav"></slot>
    </ul>
</template>

<script>
export default {
  name: 'TrucklAdminNav'
}
</script>

<style scoped lang="scss">
@import 'styles.scss';
</style>
